import { trackEvent, getVisitorId } from "./track";

export async function startStrategyCallCheckout(setLoading, details = {}) {
  const fallback = "Could not start checkout. Please try again or contact us on WhatsApp.";
  try {
    if (setLoading) setLoading(true);
    trackEvent("pay", window.location.pathname);
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payments/checkout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        lookup_key: "strategy_call_250",
        origin_url: window.location.origin,
        visitor_id: getVisitorId(),
        customer_email: details.email || null,
        customer_name: details.name || null,
        goal: details.goal || null,
        location: details.location || null,
        topic: details.topic || null,
        slot: details.slot || null,
        chat_session_id: details.chatSessionId || null,
      }),
    });
    if (!res.ok) {
      let msg = fallback;
      try {
        const d = await res.json();
        if (typeof d.detail === "string") msg = d.detail;
      } catch (e) {
        console.warn("[payments] non-JSON error response:", e?.message || e);
      }
      if (setLoading) setLoading(false);
      return { error: msg, conflict: res.status === 409 };
    }
    const data = await res.json();
    window.location.href = data.checkout_url;
    return { ok: true };
  } catch (e) {
    if (setLoading) setLoading(false);
    return { error: fallback };
  }
}
